import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "backdrop", "arrow"]

  connect() {
    // Get current template ID from URL path
    const currentTemplateId = window.location.pathname.split('/').pop()
    const storedTemplateId = sessionStorage.getItem('mobileTemplateBarTemplateId')
    const wasExpanded = sessionStorage.getItem('mobileTemplateBarExpanded') === 'true'

    this.isExpanded = false

    // Only restore expanded state if we're on the same template
    if (wasExpanded && storedTemplateId === currentTemplateId) {
      // Small delay to ensure DOM is ready
      setTimeout(() => {
        this.openWithoutAnimation()
      }, 50)
    } else {
      // Different template or first visit - clear any old state
      sessionStorage.setItem('mobileTemplateBarExpanded', 'false')
      sessionStorage.setItem('mobileTemplateBarTemplateId', currentTemplateId)
    }
  }

  disconnect() {
    // Clean up body overflow when controller is removed
    document.body.style.overflow = ''
  }

  toggle() {
    if (this.isExpanded) {
      this.close()
    } else {
      this.open()
    }
  }

  open() {
    this.panelTarget.style.transform = 'translateY(0)'
    this.backdropTarget.style.display = 'block'
    this.arrowTarget.style.transform = 'rotate(180deg)'
    this.isExpanded = true
    document.body.style.overflow = 'hidden'

    // Remember that panel is expanded and which template we're on
    const currentTemplateId = window.location.pathname.split('/').pop()
    sessionStorage.setItem('mobileTemplateBarExpanded', 'true')
    sessionStorage.setItem('mobileTemplateBarTemplateId', currentTemplateId)
  }

  openWithoutAnimation() {
    // Temporarily disable transition for instant restore
    const originalTransition = this.panelTarget.style.transition
    this.panelTarget.style.transition = 'none'

    this.panelTarget.style.transform = 'translateY(0)'
    this.backdropTarget.style.display = 'block'
    this.arrowTarget.style.transform = 'rotate(180deg)'
    this.isExpanded = true
    document.body.style.overflow = 'hidden'

    // Restore transition after a frame
    setTimeout(() => {
      this.panelTarget.style.transition = originalTransition
    }, 10)

    // Remember that panel is expanded and which template we're on
    const currentTemplateId = window.location.pathname.split('/').pop()
    sessionStorage.setItem('mobileTemplateBarExpanded', 'true')
    sessionStorage.setItem('mobileTemplateBarTemplateId', currentTemplateId)
  }

  close() {
    this.panelTarget.style.transform = 'translateY(100%)'
    this.backdropTarget.style.display = 'none'
    this.arrowTarget.style.transform = 'rotate(0deg)'
    this.isExpanded = false
    document.body.style.overflow = ''

    // Remember that panel is closed
    sessionStorage.setItem('mobileTemplateBarExpanded', 'false')
  }
}